import {
  GET_LABREQUESTSURVEYRESP_FAIL,
  GET_LABREQUESTSURVEYRESP_SUCCESS,
  GET_LABREQUESTSURVEYRESPS_FAIL,
  GET_LABREQUESTSURVEYRESPS_SUCCESS,
  ADD_LABREQUESTSURVEYRESP_SUCCESS,
  ADD_LABREQUESTSURVEYRESP_FAIL,
  UPDATE_LABREQUESTSURVEYRESP_SUCCESS,
  UPDATE_LABREQUESTSURVEYRESP_FAIL,
  DELETE_LABREQUESTSURVEYRESP_SUCCESS,
  DELETE_LABREQUESTSURVEYRESP_FAIL,  
  SET_STATE_LABREQUESTSURVEYRESP
} from "./actionTypes";

const INIT_STATE = {
  labRequestSurveyResps: [],
  labRequestSurveyResp: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestSurveyResps = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTSURVEYRESPS_SUCCESS:
      return {
        ...state,
        labRequestSurveyResps: action.payload.labRequestSurveyResps,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTSURVEYRESP:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTSURVEYRESPS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTSURVEYRESP_SUCCESS:
      return {
        ...state,
        labRequestSurveyResps: [...state.labRequestSurveyResps, action.payload],
      };

    case ADD_LABREQUESTSURVEYRESP_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTSURVEYRESP_SUCCESS:
      return {
        ...state,
        labRequestSurveyResps: state.labRequestSurveyResps.map(labRequestSurveyResp =>
          labRequestSurveyResp.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestSurveyResp }
            : labRequestSurveyResp
        ),
      };

    case UPDATE_LABREQUESTSURVEYRESP_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTSURVEYRESP_SUCCESS:
      return {
        ...state,
        labRequestSurveyResps: state.labRequestSurveyResps.filter(
          labRequestSurveyResp => labRequestSurveyResp.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTSURVEYRESP_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTSURVEYRESP_SUCCESS:
      return {
        ...state,
        labRequestSurveyResp: action.payload,
      };

    case GET_LABREQUESTSURVEYRESP_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestSurveyResps;
